import {HttpStatusCode} from "@solidjs/start";
import Container from "~/components/Container";
import Page from "~/components/Page";
import Section from "~/components/Section";
import {LinkButton} from "~/components/ui/Button";

export default function NotFound() {
    return (
        <Page metaTitle="Page Not Found" metaDescription="Sorry, This page couldn't be found">
            <Section>
                <Container>
                    <HttpStatusCode code={404}/>
                    <h1>Not Found</h1>
                    <p>Sorry, This page couldn't be found</p>
                    <LinkButton href="/" variant="primarySolid">Go Home</LinkButton>
                </Container>
            </Section>
        </Page>
    )
}